// cart-progress-bar.js — tiered progress bar (unified via PBCart)
(function () {
  const drawer = document.getElementById('UnifiedCartDrawer');
  if (!drawer) return;

  const barHost = document.getElementById('CartProgressBar');
  const msgEl   = document.getElementById('CartProgressMessage');
  if (!barHost) return;

  // --- Tiers ---
  function readTiers() {
    const nodes = drawer.querySelectorAll('[data-tier]');
    const tiers = [...nodes].map(n => ({
      id: n.dataset.id,
      threshold: Number(n.dataset.threshold || 0),
      rewardType: n.dataset.rewardType || 'free_product',
      productTitle: n.dataset.productTitle || '',
      productLabel: n.dataset.productLabel || '',
      useRemaining: n.dataset.useRemaining === 'true',
      useReached:   n.dataset.useReached === 'true',
      remainingTpl: n.dataset.remainingLabel || 'Nog {remaining_amount} om te genieten van je {product_title}!',
      reachedTpl:   n.dataset.reachedLabel   || 'Je hebt een {product_title} ontgrendeld.',
      stepLabel: n.dataset.stepLabel || '',
      stepIcon:  n.dataset.stepIcon  || ''
    }))
    .filter(t => !Number.isNaN(t.threshold))
    .sort((a, b) => a.threshold - b.threshold);

    return tiers.slice(0, 5);
  }

  function eur(cents) {
    const v = Math.max(0, Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(v); }
    catch { return '€' + v.toFixed(2).replace('.', ','); }
  }

  

function buildBar(tiers) {
  if (barHost.dataset.built) return;
  barHost.dataset.built = '1';

  const steps = tiers.map(t => {
    const icon = t.stepIcon
      ? `<img class="icon" src="${t.stepIcon}" alt="">`
      : '';
    const price = t.threshold > 0 ? eur(t.threshold * 100) : '';

    return `
      <div class="step" data-th="${t.threshold}" data-pp="${price}">
        <div class="dot">${icon}</div>
        <div class="label">${t.stepLabel || ''}</div>
      </div>
    `;
  }).join('');

  barHost.innerHTML = `
    <div class="progress-bar__wrapper">
      <div class="progress-bar__track">
        <div class="progress-bar__fill" style="width:0"></div>
      </div>
      <div class="progress-bar__steps">
        ${steps}
      </div>
    </div>
  `;
}



  function setMessage(tier, cartTotalEuros, reached) {
    if (!msgEl) return;
    const remainingCents = Math.max(0, (tier.threshold - cartTotalEuros) * 100);
    const productTitle = tier.productTitle || tier.productLabel || '';

    const apply = (tpl) =>
      (tpl || '')
        .replace(/\{remaining_amount\}/g, eur(remainingCents))
        .replace(/\{product_title\}/g, productTitle);

    const defaults = {
      remaining: {
        free_shipping:   'Nog {remaining_amount} tot gratis verzending!',
        free_product:    'Nog {remaining_amount} om te genieten van je {product_title}!',
        discount_percent:'Nog {remaining_amount} tot korting!'
      },
      reached: {
        free_shipping:   'Gratis verzending ontgrendeld.',
        free_product:    'Je hebt een {product_title} ontgrendeld.',
        discount_percent:'Korting ontgrendeld.'
      }
    };

    let tpl = '';
    if (reached) {
      tpl = tier.useReached ? tier.reachedTpl : '';
      if (!tpl) tpl = defaults.reached[tier.rewardType] || '';
    } else {
      tpl = tier.useRemaining ? tier.remainingTpl : '';
      if (!tpl) tpl = defaults.remaining[tier.rewardType] || '';
    }

    msgEl.textContent = apply(tpl);
  }

  // --- Main update ---
  function update(cartObj) {
    const tiers = readTiers();
    if (!tiers.length) return;

    buildBar(tiers);

    const fill  = barHost.querySelector('.progress-bar__fill');
    const stepEls = [...barHost.querySelectorAll('.progress-bar__steps .step')];

    const euros = (cartObj.total_price || 0) / 100;

    stepEls.forEach(el => {
      const th = Number(el.dataset.th || 0);
      el.classList.toggle('step--complete', euros >= th);
    });

    let fillPercent = 0;
    const segmentCount = tiers.length - 1;
    const segmentWidth = 100 / segmentCount;

    for (let i = 0; i < segmentCount; i++) {
      const segmentStart = tiers[i].threshold;
      const segmentEnd   = tiers[i + 1].threshold;
      const segmentRange = segmentEnd - segmentStart;

      if (euros >= segmentEnd) {
        fillPercent += segmentWidth;
      } else if (euros >= segmentStart) {
        const progress = euros - segmentStart;
        const fillInSegment = (progress / segmentRange) * segmentWidth;
        fillPercent += fillInSegment;
        break;
      } else if (euros < segmentStart && i === 0) {
        const progress = euros;
        const fillInSegment = (progress / segmentStart) * segmentWidth;
        fillPercent += fillInSegment;
        break;
      } else {
        break;
      }
    }

    fillPercent = Math.min(100, Math.max(0, fillPercent));
    if (fill) fill.style.width = fillPercent + '%';

    let active = tiers.find(t => euros < t.threshold);
    if (!active) {
      active = tiers[tiers.length - 1];
      setMessage(active, euros, true);
    } else {
      setMessage(active, euros, false);
    }
  }

  // --- Hooks ---
  async function refresh() {
    try {
      const gqlCart = await PBCart.refresh();
      const cart = {
        total_price: Math.round(parseFloat(gqlCart.cost?.subtotalAmount?.amount || 0) * 100)
      };
      update(cart);
    } catch (e) {
      // ignore errors
    }
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('pb:cart:updated', e => {
    const gqlCart = e.detail?.cart;
    if (gqlCart) {
      const cart = {
        total_price: Math.round(parseFloat(gqlCart.cost?.subtotalAmount?.amount || 0) * 100)
      };
      update(cart);
    }
  });
  document.addEventListener('cart:open', refresh);
})();